import { createFileRoute } from '@tanstack/react-router'
import { LibraDashboardPage } from 'pages/libraDashboard/LibraDashboardPage'

export const Route = createFileRoute('/nii-dashboard/')({
  component: LibraDashboardPage,
  staticData: {
    title: 'NII Dashboard',
  },
})
